const CommonButton = ({
  children,
  isPrimary,
  isWarning,
  isSecondary,
  hasBorder,
  isLarge,
  isBold = true,
  to,
  className,
  type = "button",
  applyMinWidth = true,
  isSmall,
  isMargin = false,
  ...args
}) => {
  return (
    <button
      type={type}
      style={{ margin: isMargin ? "15px auto" : 0 }}
      className={`${"btn"} ${
        isPrimary
          ? "primary-btn"
          : isWarning
          ? "red-btn"
          : isSecondary
          ? "secondary-btn"
          : ""
      } ${hasBorder ? "btn-border" : ""} ${isLarge ? "large-btn" : ""} ${
        isBold ? "bold-text" : ""
      } ${applyMinWidth ? "minWidth" : ""} ${
        isSmall ? "small-btn" : ""
      } ${className}
      `}
      {...args}
    >
      {children}
    </button>
  );
};

export default CommonButton;
